// Bottom status bar. Segments that can be real, are real.
import React, { useState, useEffect } from 'react';
import { relativeTime } from '../../hooks/useGitHub';
import { BranchIcon } from './Icons';

const MY_TZ = 'Asia/Kolkata';

const timeIn = (tz) =>
  new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: tz
  }).format(new Date());

const formatUptime = (secs) => {
  const h = String(Math.floor(secs / 3600)).padStart(2, '0');
  const m = String(Math.floor((secs % 3600) / 60)).padStart(2, '0');
  const s = String(secs % 60).padStart(2, '0');
  return `${h}:${m}:${s}`;
};

const StatusBar = ({ github, traceSummary }) => {
  const [now, setNow] = useState(() => Date.now());
  const [startedAt] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const showBothClocks = viewerTz !== MY_TZ;
  const uptime = formatUptime(Math.floor((now - startedAt) / 1000));
  const lastPush = relativeTime(github.lastPush);

  return (
    <div className="status-bar">
      <div className="status-left">
        <span className="status-mode">NORMAL</span>
        <span className="status-seg status-seg-border">
          <BranchIcon /> main
        </span>
        {lastPush && (
          <span className="status-seg status-seg-border">
            <span className="status-dot" /> github · last push {lastPush}
          </span>
        )}
        {github.status === 'ready' && (
          <span className="status-seg">{github.repos.length} public repos</span>
        )}
      </div>
      <div className="status-right">
        {traceSummary && <span className="status-seg status-seg-left">{traceSummary}</span>}
        <span className="status-seg status-seg-left status-seg-clock">
          {showBothClocks
            ? `Bengaluru ${timeIn(MY_TZ)} · you ${timeIn(viewerTz)}`
            : `Bengaluru ${timeIn(MY_TZ)}`}
        </span>
        <span className="status-seg status-seg-left">up {uptime}</span>
        <span className="status-seg status-seg-left">utf-8</span>
      </div>
    </div>
  );
};

export default StatusBar;
